import { render, staticRenderFns } from "./customer-filter.vue?vue&type=template&id=dec3676c&scoped=true&"
import script from "./customer-filter.vue?vue&type=script&lang=js&"
export * from "./customer-filter.vue?vue&type=script&lang=js&"
import style0 from "./customer-filter.vue?vue&type=style&index=0&id=dec3676c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec3676c",
  null
  
)

export default component.exports